import { Stack, Group } from '@mantine/core';
import { AfaModal, AfaAlert, AfaButton } from '../../ui';
import ApiService from '../../../utils/ApiService';
import { useState } from 'react';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';

interface DeleteTramesaModalProps {
  apiService: ApiService;
  opened: boolean;
  onClose: () => void;
  tramesaId: any;
}

export function DeleteTramesaModal({ apiService, opened, onClose, tramesaId }: DeleteTramesaModalProps) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsSubmitting(true);
    e.preventDefault();
    apiService.DeleteTramesa(tramesaId)
    .then((result: any) => {
      if(result?.data?.success === true) {
        setIsSubmitting(false);
        navigate(`/trameses/consultar`);
      }
      else {
        setIsSubmitting(false);
        notifications.show({
          title: "Error",
          message: result.message || "S'ha produït un error inesperat.",
          color: "red",
        });
      }
    })
    .catch((error: any) => {
      setIsSubmitting(false);
        notifications.show({
          title: "Error",
          message: error.message || "S'ha produït un error inesperat.",
          color: "red",
        });
    })
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <AfaModal
      opened={opened}
      onClose={handleClose}
      title="Esborrar tramesa"
      size="md"
      centered
    >
      <form onSubmit={handleSubmit}>
        <Stack mt="sm" gap="md">
          <div style={{ width: '100%' }}>
            <AfaAlert type="warning" variant="light" title="Esborrar tramesa">
              Si esborres aquesta tramesa, no es podrà recuperar. Aquesta acció és irreversible.
            </AfaAlert>
          </div>

          <Group justify="flex-end">
            <AfaButton 
              id="btn-cancelar-ara" 
              variant="filled" 
              color="red" 
              type="submit"
              loading={isSubmitting}
            >
              Esborrar ara
            </AfaButton>
          </Group>
        </Stack>
      </form>
    </AfaModal>
  );
}
